export default __webpack_public_path__ + "static/media/emoji-sad.6ba7fb8c.svg";